/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import { MultiSelect, DropdownSkeleton } from 'carbon-components-react';
import PropTypes from 'prop-types';
import AuditRepository from '../../../helpers/api/AuditRepository';

export default class FunctionMultiSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      items: [],
      selectedItems: [],
      lengthProcesses:0
    };
    this.onChange = this.onChange.bind(this);
    this.repository = new AuditRepository();
  }

  async componentDidMount() {
    this.setState({ loading: true });
    const items = await this.getItems();
    this.setState({ items, selectedItems: this.props.initialSelectedItems.functions, lengthProcesses:  this.props.initialSelectedItems.processes.length,loading: false });
  }

  onChange = (selectedItem) => {
    const items = selectedItem ? selectedItem.selectedItems : null;
    this.setState({
      selectedItems: items,
    });
    this.props.onChange(items);
  };

  getItems = async () => {
    let items = [];
    try {
      items = await this.repository.getFunctions();
    } catch (error) {
      console.error(error);
      this.props.onError(error);
    }
    return items;
  };
  
  render() {
    if(this.props.initialSelectedItems.processes.length!==this.state.lengthProcesses && this.state.selectedItems?.length > 0)
    {
      this.state.lengthProcesses= this.props.initialSelectedItems.processes.length;
      var selectedItem = {selectedItems:this.state.selectedItems.filter((a)=> this.props.initialSelectedItems.processes.some((b)=>b.id===a.idAuditProcess))}
      this.onChange(selectedItem);
    }  
    return this.state.loading ? (
      <DropdownSkeleton />
    ) : (
      <MultiSelect.Filterable
        id="auditSubprocessSelect"
        key= {`idAuditSubProcess${this.state.selectedItems?.length}`}
        name="auditSubprocessSelect"
        disabled={(this.state.items < 1 || this.props.disabled )&& this.props.initialSelectedItems.processes.length===0}
        placeholder={
          this.state.selectedItems < 1
            ? 'Choose one or more Subprocess'
            : this.state.selectedItems?.map((elem) => elem.name).join(', ')
        }
        itemToString={(item) => (item ? item && item.name : '')}
        items={this.state.items.filter((elA)=>this.props.initialSelectedItems.processes.some((elB)=>elB.id===elA.idAuditProcess))}
        light={false}
        onChange={this.onChange}
        type="default"
        initialSelectedItems={this.props.initialSelectedItems.functions}
      />
    );
  }
}

FunctionMultiSelect.propTypes = {
  invalid: PropTypes.bool,
  invalidText: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  initialSelectedItems: PropTypes.array,
  disabled: PropTypes.bool,
};
FunctionMultiSelect.defaultProps = {
  invalid: false,
  invalidText: '',
  initialSelectedItems: [],
  disabled: true,
};
